import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const XmlFileImage = (t0)=>{
    const $ = c(9);
    const { width: t1, height: t2 } = t0;
    const width = void 0 === t1 ? 56 : t1;
    const height = void 0 === t2 ? 56 : t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.4064 5H35.5L48.9999 18.8V45.0115C48.9999 48.3218 46.1974 50.9999 42.7453 50.9999H19.2666C15.8025 50.9999 13 48.3218 13 45.0115V10.9884C12.9999 7.6781 15.9423 5 19.4064 5Z",
            fill: "#E2E6EB"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M35.5289 14.384V5L48.9999 18.8L40.0192 18.8C35.9779 18.8 35.3418 15.856 35.5289 14.384Z",
            fill: "#BAC6D1"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M7 33C7 30.7909 8.79086 29 11 29H38C40.2091 29 42 30.7909 42 33V43C42 45.2091 40.2091 47 38 47H11C8.79086 47 7 45.2091 7 43V33Z",
            fill: "#E98C00"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M32.292 42.7273V33.2728H34.291V41.0792H38.3442V42.7273H32.292Z",
            fill: "white"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M20.3965 33.2728H22.8617L25.4654 39.625H25.5762L28.1799 33.2728H30.6451V42.7273H28.7062V36.5736H28.6277L26.181 42.6812H24.8607L22.4139 36.5505H22.3354V42.7273H20.3965V33.2728Z",
            fill: "white"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M12.9778 33.2728L14.8844 36.4951H14.9583L16.8742 33.2728H19.1316L16.2463 38L19.1962 42.7273H16.8972L14.9583 39.5004H14.8844L12.9455 42.7273H10.6558L13.6149 38L10.7112 33.2728H12.9778Z",
            fill: "white"
        });
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
    } else {
        t3 = $[0];
        t4 = $[1];
        t5 = $[2];
        t6 = $[3];
        t7 = $[4];
        t8 = $[5];
    }
    let t9;
    if ($[6] !== height || $[7] !== width) {
        t9 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 56 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t3,
                t4,
                t5,
                t6,
                t7,
                t8
            ]
        });
        $[6] = height;
        $[7] = width;
        $[8] = t9;
    } else t9 = $[8];
    return t9;
};
export { XmlFileImage };
